var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H17V4C17 2.897 16.103 2 15 2H9C7.897 2 7 2.897 7 4V6H4C2.897 6 2 6.897 2 8V11H22V8C22 6.897 21.103 6 20 6ZM9 4H15V6H9V4ZM14 14H10V12H2V19C2 20.103 2.897 21 4 21H20C21.103 21 22 20.103 22 19V12H14V14Z",
    fill: "#CF0A2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesBag);
export default __webpack_public_path__ + "static/media/services_bag.abb8945052d77b52e1daf9e5304603ad.svg";
export { ForwardRef as ReactComponent };